import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage-cloud',
  templateUrl: './storage-cloud.component.html',
  styleUrls: []
})
export class StorageCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}